import React from 'react';

import MapComponent from '~components/map/MapComponent';
import Modal from '~components/Modal';

interface ComponentProps {
  setShowMapModal: (prop: boolean) => void;
  showMapModal: boolean;
  setMapTitle: (title: string) => void;
  mapTitle: string;
  setMapCoords: (prop: { lat: number; lng: number } | null) => void;
  mapCoords: { lat: number; lng: number } | null | undefined;
}
export const AppointmentActivitiesMapModal: React.FC<ComponentProps> = ({
  setShowMapModal,
  showMapModal,
  mapCoords,
  mapTitle,
  setMapCoords,
  setMapTitle,
}) => {
  return (
    <Modal
      setIsOpen={setShowMapModal}
      isOpen={showMapModal}
      bodyClassName="m-0 p-0"
      className="features"
      header={mapTitle}
      headerClassName="header"
      includeFooter={false}
      size="xl"
      onClosed={() => {
        setMapCoords(null);
        setMapTitle('');
      }}
    >
      <MapComponent
        style={{ height: '60vh', padding: 0 }}
        mapId={'Appointments-Map'}
        defaultZoom={10}
        elements={[
          {
            position: { ...(mapCoords ?? { lat: 0, lng: 0 }) },
          },
        ]}
        defaultCenter={mapCoords ?? { lat: 0, lng: 0 }}
      />
    </Modal>
  );
};
export default AppointmentActivitiesMapModal;
